import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { AltitudeRangeState } from "../altitudeRangeReducer";

export const changeUnitsPartialReducer: IPartialReducer<AltitudeRangeState> = (state, action) => {
    return {
        ...state,
        units: action.units,
    };
};
